module.exports = __webpack_public_path__ + "img/bjk.c8a14356.png";